module.exports = __webpack_public_path__ + "static/media/ResultOesophage.09709744.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ResultOesophage.jpg
// module id = 514
// module chunks = 0